import React from "react";
import { IconButton, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { getIconByEstadoDocumental } from "../ListadoSolicitud.iconMaps";

// Columna "Documental": ícono según idEstadoVerificacionDocumental, con caso
// especial cuando es firma Yupana en Estado 6 sin firma electrónica aún.
export default function CeldaDocumental({
  data,
  isError,
  estaDeshabilitado,
  estadoDeshabilitadoDocumental,
  verificacionSolicitud,
  handledocumentos,
  handlePopoverOpen,
}) {
  const esFirmaElectronica = Number(data.TipoFirmaElectronica) === 1;
  const esCasoEspecialFirma =
    esFirmaElectronica &&
    Number(data.Estado) === 6 &&
    Number(data.idFirmaElectronica) === 0;
  // TipoFirmaElectronica=1 pero Estado != 6 → no mostrar el botón documental
  const ocultarBotonDocumental = esFirmaElectronica && Number(data.Estado) !== 6;

  return (
    <TableCell align="center">
      <div>
        <span>
          {!ocultarBotonDocumental && (
          <IconButton
            onClick={() => handledocumentos(data)}
            disabled={
              esCasoEspecialFirma
                ? false
                : estaDeshabilitado(data) ||
                  estadoDeshabilitadoDocumental(data) ||
                  verificacionSolicitud(data)
            }
            size="small"
            sx={{
              opacity: estaDeshabilitado(data) ? 0.4 : 1,
              bgcolor: isError ? "#fee2e2" : "#f1f5f9",
              "&:hover": {
                bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                transform: "scale(1.1)",
              },
              transition: "all 0.2s ease",
            }}
          >
            {esCasoEspecialFirma ? (
              <CheckCircleIcon sx={{ color: "rgb(56, 142, 60)" }} />
            ) : (
              getIconByEstadoDocumental(data.idEstadoVerificacionDocumental)
            )}
          </IconButton>
          )}

          {/* InfoIcon al lado del IconButton */}
          <span
            style={{
              // pointerEvents: estaDeshabilitado(data)
              //   ? "none"
              //   : "auto",
              // opacity: estaDeshabilitado(data) ? 0.5 : 1,
            }}
          >
            <MoreVertIcon
              onClick={(event) =>
                handlePopoverOpen(event, 3, data)
              }
              style={{ cursor: "pointer" }}
            />
          </span>
        </span>

      </div>
    </TableCell>
  );
}
